export default "__VITE_ASSET__BiXHDK5E__"